import React, { forwardRef, useState, useImperativeHandle } from "react";
import Modal from "@mui/material/Modal";
import "./ExpertModal.css";
import { expertsData } from "../../../data/Oracle/expert.js";

const ExpertModal = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [expert, setExpert] = useState({});
  const [expertCertification, setExpertCertification] = useState([]);
  const [expertSkills, setExpertSkills] = useState([]);

  useImperativeHandle(ref, () => ({
    handleOpen(expert_ename) {
      let expertObj = expertsData.filter((obj) => {
        return obj.ename === expert_ename;
      })[0];
      setExpert(expertObj);
      setExpertCertification(expertObj["certification-acquired"].slice(0, 6));
      setExpertSkills(expertObj["skill-sets"].slice(0, 6));
      setOpen(true);
    },
  }));

  const handleViewMore = () => {
    setExpertCertification(expert["certification-acquired"]);
  };

  const handleViewLess = () => {
    setExpertCertification(expert["certification-acquired"].slice(0, 6));
  };

  const handleViewMoreSkills = () => {
    setExpertSkills(expert["skill-sets"]);
  };

  const handleViewLessSkills = () => {
    setExpertSkills(expert["skill-sets"].slice(0, 6));
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      hideBackdrop
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className="expert_main-model"
    >
      <div className="model_experts">
        <div key={expert.ename}>
          <div className="model_heading_experts">
            <a href={`mailto:${expert.email}`} target="_blank" rel="noreferrer">
              <p className="model-name">{expert.name}</p>
            </a>

            <p className="model-name1">{/* <b>Email Id</b> - {item.EID} */}</p>
            <span className="experts_close_btn_model" onClick={handleClose}>
              <img
                src="/images/Experts/close_img.png"
                alt="icon"
                className="experts_close_img"
              />
            </span>
          </div>
          <img
            src="/images/Experts/top line.png"
            alt="Experts-img"
            className="topline-img"
          />
          <div className="header_experts">
            <img
              src="/images/Experts/Skill sets.png"
              alt="icon"
              className="skill_set_img"
            />
            <p className="para_experts">Skill sets</p>
          </div>
          <div className="skill_sets_data">
            {expertSkills.map((item) => {
              return (
                <div className="skill_sets_content">
                  <img
                    src="/images/Experts/Bulletpoint.png"
                    alt="icon"
                    className="skill_bullet_point_img"
                  />
                  <p className="skill_bullet_point_text">{item}</p>
                </div>
              );
            })}
          </div>
          <div className="expert_viewmore_sp">
            {expert["skill-sets"] !== undefined &&
            expertSkills.length === expert["skill-sets"].length &&
            expertSkills.length > 6 ? (
              <span onClick={handleViewLessSkills}>View less</span>
            ) : (
              ""
            )}
            {expert["skill-sets"] !== undefined &&
            expertSkills.length !== expert["skill-sets"].length ? (
              <span onClick={handleViewMoreSkills}>View more</span>
            ) : (
              ""
            )}
          </div>
          <img
            src="/images/Experts/Middle line.png"
            alt="Experts-img"
            className="topline-img"
          />
          <div className="header_experts">
            <img
              src="/images/Experts/Certification Acquired.png"
              alt="icon"
              className="skill_set_img"
            />
            <p className="para_experts">Certification Acquired</p>
          </div>
          <div className="skill_sets_data">
            {expertCertification.map((item) => {
              return (
                <div className="skill_sets_content">
                  <img
                    src="/images/Experts/Bulletpoint.png"
                    alt="icon"
                    className="skill_bullet_point_img"
                  />
                  <p className="skill_bullet_point_text1">{item}</p>
                </div>
              );
            })}
          </div>
          <div className="expert_viewmore_sp">
            {expert["certification-acquired"] !== undefined &&
            expertCertification.length ===
              expert["certification-acquired"].length &&
            expertCertification.length > 6 ? (
              <span onClick={handleViewLess}>View less</span>
            ) : (
              ""
            )}
            {expert["certification-acquired"] !== undefined &&
            expertCertification.length !==
              expert["certification-acquired"].length ? (
              <span onClick={handleViewMore}>View more</span>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
});

export default ExpertModal;
